import styled from 'styled-components';
import { mediaQueries } from '@general/breakpoints';

const MarketingCards = styled.div`
    display: block;
    margin-left: -16px;
    margin-right: -16px;

    @media ${mediaQueries.xxl} {
        display: flex;
    }

    .marketing-card {
        margin-bottom: 24px;
        margin-left: 16px;
        margin-right: 16px;

        @media ${mediaQueries.xxl} {
            margin-bottom: 0;
            width: 100%;
        }
    }
`;

export default MarketingCards;
